export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./RegistrationModal.vue?vue&type=template&id=cba43918&"


//////////////////
// WEBPACK FOOTER
// ./src/components/RegistrationModal.vue?vue&type=template&id=cba43918&
// module id = 542
// module chunks = 0